.atm_ge_glywfm.atm_ge_glywfm{list-style-type:none;}
.atm_lk_idpfg4.atm_lk_idpfg4{padding-left:0;}
